import React from 'react';
import { Box, Typography } from '@mui/material';
import useAppTheme from 'hooks/useAppTheme';
import { useChatbotContext } from '../context/ChatbotContext';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface UserQuestionBubbleProps {
  message: string | React.ReactNode;
  isHighlight: boolean;
}

export const UserQuestionBubble: React.FC<UserQuestionBubbleProps> = ({
  message,
  isHighlight,
}) => {
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const { isExpanded } = useChatbotContext();
  const borderColor = isHighlight
    ? enableDarkTheme
      ? '#E2E8F0'
      : palette.primary
    : enableDarkTheme
    ? 'rgba(100, 149, 237, 0.3)'
    : '#A3BFFA';
  const border = isHighlight ? '2px dashed' : '2px solid ';
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      <Box
        sx={{
          maxWidth: '80%',
          py: 1,
          px: 2,
          borderRadius: '20px 20px 5px 20px',
          border,
          backgroundColor: enableDarkTheme
            ? ' rgba(100, 149, 237, 0.15)'
            : '#E8F0FF',
          color: enableDarkTheme ? '#FFFFFF' : '#1E3A8A',
          borderColor,
          boxShadow: enableDarkTheme ? 'none' : '0 2px 6px rgba(0,0,0,0.05)',
          transition: 'all 0.2s ease',
        }}
      >
        <Typography
          component="div"
          sx={{
            fontSize: isExpanded ? '0.9rem' : '0.8rem',
            wordBreak: 'break-word',
          }}
        >
          {message}
        </Typography>
      </Box>
    </Box>
  );
};
